<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
<!--    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">-->

      <div style="margin-top: 50px;">
        <a-row  style="margin-top: 20px">
          <a-col :span="8">
            <a-button @click="handleStart(record)"  v-if="record.status == 1"  v-hasPermi="['live:live:start']">
              <a-icon type="edit" />{{$t('开启直播')}}
            </a-button>
            <a-button @click="handleClose(record)" v-if="record.status == 2" v-hasPermi="['live:live:remove']">
              <a-icon type="delete" />{{$t('关闭直播')}}
            </a-button>
          </a-col>

        </a-row>
        <a-row  style="margin-top: 30px">
          <a-col :span="8">
            <a-button type="primary" @click="$refs.createFormRedPacket.handleAdd(record)"  v-hasPermi="['live:live:redpacket']">
            {{$t('发红包')}}
            </a-button>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="$refs.createFormRedPacketRecord.handleLiveData(record)"  v-hasPermi="['live:live:redpacket']">
              {{$t('红包领取列表')}}
            </a-button>
          </a-col>
        </a-row>
        <a-row  style="margin-top: 30px">
          <a-col :span="8">
            <a-button type="primary" @click="$refs.createFormCoupon.handleAdd(record)"   v-hasPermi="['live:live:addcoupon']">
              {{$t('发优惠券')}}
            </a-button>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="$refs.createFormGoods.handleUpdate(record)"  v-hasPermi="['live:live:addgoods']">
              {{$t('上架商品')}}
            </a-button>
          </a-col>
        </a-row>
        <a-row  style="margin-top: 30px">
          <a-col :span="8">
            <a-button type="primary" @click="$refs.createFormLottery.handleUpdate(record)"   v-hasPermi="['live:live:choujiang']">
              {{$t('创建抽奖')}}
            </a-button>
          </a-col>
          <a-col :span="8">
            <a-button type="primary"  @click="$refs.createFormLotteryRecord.handleLiveData(record)"  v-hasPermi="['live:live:choujiang']">
              {{$t('抽奖列表')}}
            </a-button>

          </a-col>

        </a-row>

        <a-row  style="margin-top: 30px">
          <a-col :span="8">
            <a-button type="primary"  @click="huizhi(record)"  v-hasPermi="['live:live:choujiang']">
              {{$t('创建签到回执')}}
            </a-button>
          </a-col>

<!--          <a-col :span="8">-->
<!--            <a-button type="primary"  @click="huizhiList(record)"  v-hasPermi="['live:live:choujiang']">-->
<!--              {{$t('签到回执列表详情')}}-->
<!--            </a-button>-->
<!--          </a-col>-->
        </a-row>
      </div>

      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel">
            {{$t('关闭')}}
          </a-button>
        </a-space>
      </div>
    <create-form-red-packet ref="createFormRedPacket"  @ok="getList"/>
    <create-form-red-packet-record ref="createFormRedPacketRecord"  @ok="getList"/>
    <create-form-coupon ref="createFormCoupon"  @ok="getList"/>
    <create-form-goods ref="createFormGoods"  @ok="getList"/>
    <create-form-lottery ref="createFormLottery"  @ok="getList"/>
    <create-form-lottery-record ref="createFormLotteryRecord"  @ok="getList"/>

<!--    </a-form-model>-->
  </a-drawer>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import CreateFormRedPacket from "@/views/live/live/modules/CreateFormRedPacket.vue";
import CreateFormRedPacketRecord from "@/views/live/live/modules/CreateFormRedPacketRecord.vue";
import CreateFormCoupon from "@/views/live/live/modules/CreateFormCoupon.vue";
import CreateFormGoods from "@/views/live/live/modules/CreateFormGoods.vue";
import CreateFormLottery from "@/views/live/live/modules/CreateFormLottery.vue";
import CreateFormLotteryRecord from "@/views/live/live/modules/CreateFormLotteryRecord.vue";
import {createHuizhi, endLive, startLive} from "@/api/live/live";

export default {
  name: 'LiveOperationModal',
  props: {
  },
  components: {
    CreateFormLotteryRecord,
    CreateFormLottery,
    CreateFormGoods,
    CreateFormCoupon,
    CreateFormRedPacketRecord,
    CustomDictTag,
    CreateFormRedPacket,

  },
  data () {
    return {
      record: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      liveId:null,

      liveData:{

      },

      // 1增加,2修改
      formType: 1,
      open: false,
      loading: false,
      tableList:[],
      total: 0,
      pageSizeOptions: ['10', '20', '50', '100'],
      queryParam: {
        liveId: undefined,
        nickName: undefined,
        pageNum: 1,
        pageSize: 10
      },

    }
  },
  filters: {
  },
  created () {

  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    huizhi (record) {
      console.log(record)
      createHuizhi({"id":record.id}).then(response => {
        this.$message.success(
          '创建成功',
          3
        )
      })
    },
    handleStart (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let param = {};
      param.id = ids;
      startLive(param).then(response => {
        this.$message.success(
          '开启成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
        // this.getList();
      })
    },

    /** 关闭直播 */
    handleClose (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let param = {};
      param.id = ids;
      endLive(param).then(response => {
        this.$message.success(
          '关闭成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
        this.getList()
      })
    },


    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },

    // 表单重置
    reset () {
    },

    /** 查询直播数据统计 */
    handleLiveData (row) {
      this.record = row
      console.log( 111,this.record)
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('直播操作')
    },




  }
}
</script>
<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
